const API_BASE_URL = process.env.REACT_APP_API_BASE_URL ?? 'http://localhost:4000';

export class ApiError extends Error {
  status: number;
  details: unknown;

  constructor(message: string, status: number, details: unknown = null) {
    super(message);
    this.status = status;
    this.details = details;
  }
}

interface MagicLinkPayload {
  email: string;
  captchaToken: string;
}

export const requestMagicLink = async ({ email, captchaToken }: MagicLinkPayload): Promise<void> => {
  const response = await fetch(`${API_BASE_URL}/api/auth/magic-link`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    credentials: 'include',
    body: JSON.stringify({ email, captchaToken })
  });

  if (!response.ok) {
    let details: unknown = null;
    try {
      details = await response.json();
    } catch (error) {
      // ignore body parse errors
    }

    const message = (details as { error?: string } | null)?.error ?? 'Failed to request sign-in link.';
    throw new ApiError(message, response.status, details);
  }
};
